/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.CampaignId', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.CampaignType', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.CampaignType.Values', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Channel', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Channel.Values', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Feature', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Feature.Values', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Recipient', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.Recipient.Values', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.displayName = 'proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup;
  return proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values = {
  INVALID: 0,
  HEALTH_ALERTS: 1,
  CCM_UNSPECIFIED: 2,
  FRIENDS_AND_FAMILY: 3,
  AFL_ONEAPP: 4,
  SOLO_PLUS: 5
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.Feature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.Feature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.Feature.displayName = 'proto.com.teladoc.protobuf.common.user.communication.Feature';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.Feature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Feature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Feature}
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.Feature;
  return proto.com.teladoc.protobuf.common.user.communication.Feature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Feature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Feature}
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.Feature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Feature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.Feature.Values = {
  INVALID: 0,
  BG_ALERT: 1,
  HF_ALERT: 2,
  NUDGE_FOLLOW_UP: 3,
  BG_ALERT_FF: 4,
  USER_SHARES: 5,
  CONTACT_COMM_PREF_CHANGE_NOTIFICATION: 6,
  SCHEDULE_COACHING_SESSION: 7,
  INTOUCH_NUDGE_ACTION_FOLLOW_UP: 8,
  MULTI_FACTOR_AUTHENTICATION: 9,
  CHALLENGE_REMINDER: 10,
  MH_REASSESSMENT: 11,
  MH_REENGAGEMENT: 12,
  MH_SLEEP: 13,
  ACTION_PLAN: 14,
  CCM_GENERIC: 15,
  HTN_ALERT: 16,
  AFL_MFA: 17,
  SOLO_CORE: 18
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.Channel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.Channel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.Channel.displayName = 'proto.com.teladoc.protobuf.common.user.communication.Channel';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.Channel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Channel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Channel}
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.Channel;
  return proto.com.teladoc.protobuf.common.user.communication.Channel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Channel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Channel}
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.Channel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Channel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.Channel.Values = {
  INVALID: 0,
  SMS: 1,
  PHONE_MOBILE: 2,
  PUSH_NOTIFICATION: 3,
  EMAIL: 4
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.Recipient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.Recipient.displayName = 'proto.com.teladoc.protobuf.common.user.communication.Recipient';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.Recipient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Recipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Recipient}
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.Recipient;
  return proto.com.teladoc.protobuf.common.user.communication.Recipient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Recipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Recipient}
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.Recipient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.Recipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.Recipient.Values = {
  INVALID: 0,
  MEMBER: 1,
  NON_MEMBER: 2
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.CampaignId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.CampaignId.displayName = 'proto.com.teladoc.protobuf.common.user.communication.CampaignId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.CampaignId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CampaignId}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.CampaignId;
  return proto.com.teladoc.protobuf.common.user.communication.CampaignId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CampaignId}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.CampaignId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.teladoc.protobuf.common.user.communication.CampaignId.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.CampaignType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.CampaignType.displayName = 'proto.com.teladoc.protobuf.common.user.communication.CampaignType';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.CampaignType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CampaignType}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.CampaignType;
  return proto.com.teladoc.protobuf.common.user.communication.CampaignType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CampaignType}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.CampaignType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CampaignType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.CampaignType.Values = {
  INVALID: 0
};

goog.object.extend(exports, proto.com.teladoc.protobuf.common.user.communication);
